import React from "react";
import embededCode from "./embeded-code";
import MobilePreview from "storybookComponents/MobilePreview";
import "./style.css";

export default React.memo(({ mobileView, ...props }) => {

  return (
    <div className="hyraf-enroll-form-container">
      {
        !mobileView ?
          <div style={{ width: "100%", maxWidth: "500px", margin: "auto", paddingBottom: 20 }}>
            <iframe id="hylyEnrollForm" srcDoc={embededCode(props)} scrolling="no" style={{ width: "100%", border: "none", height: 700 }} />
          </div>
          :
          <div style={{ width: "max-content", margin: "auto" }}>
            <MobilePreview html={embededCode(props)} extraMargin={200} />
          </div>
      }

    </div>
  )
})